import React, {useEffect, useState} from "react";
import {Button} from "primereact/button";
import {InputSwitch} from "primereact/inputswitch";
import {DEFAULT_SETTINGS} from "./help-cms";
import {Card, TabHeader} from "./ui";

const GROUPS = [
    {
        title: "هلپ‌سنتر عمومی",
        description: "صفحه‌ای که همه کاربران برای مرور و جست‌وجو می‌بینند.",
        rows: [
            ["publicPopularArticles", "نمایش مقالات پربازدید"],
            ["publicNewVideos", "نمایش ویدئوهای جدید"],
            ["publicQuickStart", "نمایش مسیر شروع سریع"],
            ["publicUpdatedDate", "نمایش تاریخ به‌روزرسانی"],
        ],
    },
    {
        title: "ویجت داخل زوفینو",
        description: "کمک متناسب با صفحه‌ای که کاربر اکنون در آن است.",
        rows: [
            ["widgetPageSuggestions", "پیشنهاد براساس صفحه فعلی"],
            ["widgetVideoInPanel", "نمایش ویدئو داخل پنل"],
            ["widgetLiveSupport", "دکمه پشتیبانی آنلاین"],
            ["widgetAdvancedContent", "نمایش محتوای پیشرفته"],
        ],
    },
];

export default function SettingsTab({data, reload}) {
    const [values, setValues] = useState(DEFAULT_SETTINGS);
    const [saving, setSaving] = useState(false);
    const [message, setMessage] = useState(null);

    useEffect(() => {
        setValues({...DEFAULT_SETTINGS, ...data.settings});
    }, [data.settings]);

    const save = async () => {
        setSaving(true);
        setMessage(null);
        try {
            const payload = Object.fromEntries(Object.keys(DEFAULT_SETTINGS).map((key) => [key, Boolean(values[key])]));
            await data.api.saveSettings(payload);
            setMessage("ok");
            reload();
        } catch (e) {
            setMessage("error");
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="flex flex-column gap-3">
            <TabHeader kicker="تنظیمات نمایش" title="کاربر کجا چه چیزی ببیند؟" description="تنظیمات کم و روشن؛ جزئیات هر محتوا داخل ویرایشگر خودش."/>
            <div className="grid m-0">
                {GROUPS.map((group) => (
                    <div key={group.title} className="col-12 lg:col-6">
                        <Card title={group.title} description={group.description} className="h-full">
                            {group.rows.map(([key, label]) => (
                                <div key={key} className="flex align-items-center justify-content-between py-3 border-bottom-1 border-200 text-sm">
                                    <span>{label}</span>
                                    <InputSwitch checked={Boolean(values[key])} onChange={(e) => setValues({...values, [key]: e.value})}/>
                                </div>
                            ))}
                        </Card>
                    </div>
                ))}
            </div>
            <div className="surface-card border-1 border-200 border-round-xl p-3 flex flex-wrap align-items-center justify-content-between gap-2">
                <span className="text-xs text-500">تغییرات این بخش فقط نحوه نمایش را عوض می‌کند؛ محتوا حذف نمی‌شود.</span>
                <div className="flex align-items-center gap-3">
                    {message === "ok" && <small className="text-green-600">تنظیمات ذخیره شد.</small>}
                    {message === "error" && <small className="p-error">ذخیره انجام نشد.</small>}
                    <Button className="text-xs" label="ذخیره تنظیمات" loading={saving} onClick={save}/>
                </div>
            </div>
        </div>
    );
}
